const hasSubscription = ({ paymentDetails }) => {
  return paymentDetails?.has_subscription;
};

export default hasSubscription;
